import React, {useCallback} from 'react';

import {asCoreObject} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {handleToggleStar} from 'app-core/platform/starrable/CoreObjectStarIcon';
import isArchived from 'archive/isArchived';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import TemplateCollectionActions from 'notebook/entry-templates/collections/TemplateCollectionActions';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import {TemplateCollectionListingGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionListingGraphQL';

interface CollectionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  collection: TemplateCollectionListingGraphQL;
  isChild: boolean;
  isStarred: boolean;
}

export default function CollectionSidepanelItem(props: CollectionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, collection, isChild, isStarred} = props;
  const date = fuzzydate(collection.modifiedAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Modified '}${date}`;
  const title = collection.name;
  const icon = <BenchlingIcon icon="collection" />;

  const handleOnClick = useCallback(() => {
    TemplateCollectionActions.openCollection(collection);
  }, [collection]);

  const handleClickStar = useCallback(() => {
    handleToggleStar({
      isStarred,
      item: asCoreObject(collection),
    });
  }, [isStarred, collection]);

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(collection)}
      icon={icon}
      isCompact={isCompact}
      onClick={handleOnClick}
      parties={[{...collection.ownerJson}]}
      subTitle={subtitle}
      title={{
        text: title,
        node: <span>{title}</span>,
      }}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
      showStar={true}
      handleClickStar={handleClickStar}
      starred={isStarred}
    />
  );
}
